<template>
  <v-sheet class="mx-auto tags-list" ref="vLatestTips">
    <v-slide-group center-active show-arrows v-model="activeTagFileId">
      <!-- 共享云端【全部】胶囊：以 URL 路由状态为单一真理源严密判断高亮 -->
      <v-slide-item value="all" v-if="showAllTag" v-slot="{ active }">
        <v-btn
          class="mx-2 all-tag-btn"
          :input-value="isAllActive"
          :class="{ 'v-btn--active': isAllActive }"
          active-class="white--text"
          depressed
          rounded
          outlined
          @mouseenter="onHoverAllTag"
          @mouseleave="onCancelHover"
          @click="on_click_all_tag"
        >
          全部
        </v-btn>
      </v-slide-item>

      <!-- 各子分类胶囊：以 String(tag.fileId) 严密匹配当前路由参数，彻底杜绝任何数组偏移与错位 -->
      <v-slide-item
        v-for="(tag, index) in tagListBox"
        :key="tag.fileId || index"
        :value="String(tag.fileId)"
        :data-fileid="tag.fileId"
        v-slot="{ active }"
      >
        <v-btn
          class="mx-2"
          :input-value="isTagActive(tag.fileId)"
          :class="{ 'v-btn--active': isTagActive(tag.fileId) }"
          active-class="white--text"
          depressed
          rounded
          outlined
          @mouseenter="onHoverTagItem(tag)"
          @mouseleave="onCancelHover"
          @click="on_click_tag_item(tag, index)"
        >
          {{ tag.name }}
        </v-btn>
      </v-slide-item>
    </v-slide-group>
  </v-sheet>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import categoryCache from "@/utils/categoryCache";

export default {
  name: "tags-list",
  props: {
    tagListBox: {
      type: Array,
      default() {
        return [];
      },
    },
    lv2Categories: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      activeTagFileId: this.$route.params.materialList ? String(this.$route.params.materialList) : "all",
      tagLIst: "tagLIst",
      includeslv2: false,
      hoverTimer: null,
    };
  },
  computed: {
    showAllTag() {
      return Boolean(this.$route.params.categories && this.tagListBox && this.tagListBox.length > 0);
    },
    currentMaterialList() {
      return this.$route.params.materialList ? String(this.$route.params.materialList) : "";
    },
    isAllActive() {
      // 当处于分类库下但没有二级分类参数时，全部按钮高亮
      return !this.currentMaterialList;
    },
    ...mapState("global", [
      "navInfos",
      "lv1_ID",
      "TypeSelect",
      "sequenceType",
      "lv1ActiveItem",
      "churchLifeModel",
    ]),
  },
  watch: {
    tagListBox: function () {
      this.update_lv1_active();
    },
    $route() {
      this.update_lv1_active();
    },
  },

  created() {
    this.update_lv1_active();
  },
  methods: {
    ...mapMutations("global", [
      "updateIsListLoading",
      "updateLv1_ID",
      "updateLv2_ID",
      "updateAllCardList",
      "updateAllCardListMeta",
      "updateTypeSelect",
      "updateSequenceType",
      "updateChangeLv1ActiveItem",
    ]),

    
    // 智能悬停预取（120ms 防抖，防误触，为秒开就绪）
    onHoverAllTag() {
      clearTimeout(this.hoverTimer);
      this.hoverTimer = setTimeout(() => {
        if (this.$route.params.categories) {
          categoryCache.prefetch({
            driveIds: [this.$route.params.categories],
            lv1_categories: [],
            scenes: this.churchLifeModel || 0,
          });
        }
      }, 120);
    },

    onHoverTagItem(tag) {
      clearTimeout(this.hoverTimer);
      this.hoverTimer = setTimeout(() => {
        if (this.$route.params.categories && tag && tag.fileId) {
          categoryCache.prefetch({
            driveIds: [this.$route.params.categories],
            lv1_categories: [tag.fileId],
            scenes: this.churchLifeModel || 0,
          });
        }
      }, 120);
    },

    onCancelHover() {
      clearTimeout(this.hoverTimer);
    },

    isTagActive(fileId) {
      if (!this.currentMaterialList) return false;
      return String(fileId) === this.currentMaterialList;
    },

    on_click_all_tag() {
      if (!this.$route.params.materialList) return;
      this.GLOBAL.scrollPage = 1;
      try {
        window.scrollTo({ top: 0, behavior: "instant" });
      } catch (e) {
        window.scrollTo(0, 0);
      }
      this.activeTagFileId = "all";
      this.updateChangeLv1ActiveItem(-1);
      this.updateLv1_ID([]);
      this.$router.push(`/${this.$route.params.categories}`);
    },

    on_click_tag_item(tag, index) {
      if (String(tag.fileId) === this.currentMaterialList) return;
      this.GLOBAL.scrollPage = 1;
      try {
        window.scrollTo({ top: 0, behavior: "instant" });
      } catch (e) {
        window.scrollTo(0, 0);
      }
      this.activeTagFileId = String(tag.fileId);
      this.updateChangeLv1ActiveItem(index);
      this.$router.push(
        `/${this.$route.params.categories}/${tag.fileId}`
      );
      this.updateLv1_ID([tag.fileId]);
      this.updateLv2_ID([this.GLOBAL.activeLv2Id]);
    },

    update_lv1_active() {
      const currentLv1 = this.$route.params.materialList ? String(this.$route.params.materialList) : "";
      if (!currentLv1) {
        this.activeTagFileId = "all";
        this.updateChangeLv1ActiveItem(-1);
        return;
      }

      this.activeTagFileId = currentLv1;

      // 定位并高亮对应分类，联动三级菜单
      const currentIndex = this.tagListBox.findIndex(
        (item) => String(item.fileId) === currentLv1
      );

      if (currentIndex !== -1) {
        this.updateChangeLv1ActiveItem(currentIndex);
        const item = this.tagListBox[currentIndex];

        // 处理一二级菜单交互
        if (this.lv2Categories.length < 1) return;
        let lv1IncludesLv2 = item.lv2names || [];
        let lv2Name = $(".tag-list .active").text();
        if (lv1IncludesLv2.includes(lv2Name)) {
          this.$emit("get_list_data");
        } else {
          this.GLOBAL.activeLv2Id = "";
          $(".tag-list").find("button").removeClass("active");
          $(".tags-list").find("button").removeClass("include-lv2");
        }
        $(".tag-list button").removeClass("lv1-children");

        setTimeout(() => {
          $(".tag-list button").map((idx, v) => {
            if (lv1IncludesLv2.includes($(v).text())) {
              $(v).addClass("lv1-children");
            }
          });
        }, 300);
      }
    },
  },
};
</script>

<style lang="scss">
.tags-list {
  .v-btn--active {
    background: linear-gradient(135deg, #10b981 0%, #0d9488 100%) !important;
    border-color: #0d9488 !important;
    color: #ffffff !important;
    box-shadow: 0 4px 12px -2px rgba(13, 148, 136, 0.35);
  }
  margin-bottom: 16px;
  width: 100%;
  background: transparent !important;

  .v-btn {
    border-color: #cde6df !important;
    background-color: rgba(255, 255, 255, 0.9);
    color: $color-normal;
    font-weight: 600;
    letter-spacing: 0.02em;
    transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);

    &:hover:not(.v-btn--active) {
      background-color: $color-mint-light;
      border-color: $color-emerald !important;
      color: $color-bright;
    }
  }

  .include-lv2 {
    background: $color-mint-soft !important;
    border-color: $color-emerald !important;
    color: $color-bright !important;
  }

  .v-item-group {
    align-items: center;
    padding: 4px;
  }

  .v-slide-group__next,
  .v-slide-group__prev {
    flex: 0 1 38px;
    width: 38px;
    min-width: 38px;
    height: 38px;
    border-radius: 50%;
    background: #ffffff;
    border: 1px solid #d5e8e3;
    box-shadow: 0 4px 12px rgba(13, 148, 136, 0.12);
    transition: all 0.2s ease;

    &:hover:not(.v-slide-group__prev--disabled):not(.v-slide-group__next--disabled) {
      background: $color-mint-light;
      border-color: $color-emerald;
    }

    .v-icon.v-icon {
      font-size: 26px;
      color: $color-bright;
    }
    &.v-slide-group__prev--disabled,
    &.v-slide-group__next--disabled {
      opacity: 0.5;
      .v-icon.v-icon {
        font-size: 26px;
        color: #b8cfc9 !important;
      }
    }
  }
}
</style>
